import { authenticatedClient } from '../lib/client';
import { TOOLS_ENDPOINTS } from './tools.utils';
import type { ApiResponse } from '../lib/types';
import type { Tool } from './tools.types';

export const getTools = async (): Promise<ApiResponse<Tool[]>> => {
    try {
        const response = await authenticatedClient.get(TOOLS_ENDPOINTS.GET_ALL);
        // console.log("Tools:", response.data);
        return { data: response.data };
    } catch (error: any) {
        return { error: error.response?.data?.message || 'Failed to fetch tools' };
    }
};

export const getToolById = async (toolId: string): Promise<ApiResponse<Tool>> => {
    try {
        const response = await authenticatedClient.get(TOOLS_ENDPOINTS.GET_BY_ID(toolId));
        // console.log("Tool:", response.data);
        return { data: response.data };
    } catch (error: any) {
        return { error: error.response?.data?.message || 'Failed to fetch tool' };
    }
};

export const createTool = async (payload: Tool): Promise<ApiResponse<Tool>> => {
    try {   
        const response = await authenticatedClient.post(TOOLS_ENDPOINTS.CREATE, payload);
        return { data: response.data };
    } catch (error: any) {
        return { error: error.response?.data?.message || 'Failed to create tool' };
    }
};

export const updateTool = async (
    toolId: string,
    payload: Tool
): Promise<ApiResponse<Tool>> => {
    try {
        const response = await authenticatedClient.patch(TOOLS_ENDPOINTS.UPDATE(toolId), payload);
        return { data: response.data };
    } catch (error: any) {
        return {
            error: error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                'Failed to update tool'
        };
    }
};

export const deleteTool = async (toolId: string): Promise<ApiResponse<Tool>> => {
    try {
        const response = await authenticatedClient.delete(TOOLS_ENDPOINTS.DELETE(toolId));
        // console.log("Deleted tool:", response.data);
        return { data: response.data };
    } catch (error: any) {
        return { error: error.response?.data?.message || 'Failed to delete tool' };
    }
};
